import moment from 'moment';
import React from 'react';

import { getDateDifference } from '@utils/Util';

const EtdDetails = ({ selectedStyleDetails, selectedStyle }) => (
	<div className="date-status">
		<div className="d-flex">
			<ul className="d-flex flex-wrap etd-date-list">
				<li className="regular-12 gray_dark_02">
					Order received:{' '}
					<span className="gray_dark_01">
						{' '}
						{moment(selectedStyleDetails?.orderStartDate).format('DD MMM, YY')}{' '}
					</span>
				</li>

				<li className="regular-12 gray_dark_02">
					Buyer ETD:{' '}
					<span className="gray_dark_01">
						{moment(selectedStyleDetails?.deliveryDate).format('D MMM, YY')}{' '}
						{`(${
							getDateDifference(
								selectedStyleDetails?.factoryHandOverDate,
								selectedStyleDetails?.factoryDeliveryDate
							) + 'd'
						})`}
					</span>
				</li>
				<li className="regular-12 gray_dark_02">
					Planned ETD:{' '}
					<span className="gray_dark_01">
						{selectedStyle?.estimatedDeliveryDate && (
							<span>{moment(selectedStyle.estimatedDeliveryDate).format('D MMM, y')}</span>
						)}
						&nbsp;
						{selectedStyle?.timeOfCompletion && `(${selectedStyle.timeOfCompletion}d)`}
					</span>
				</li>
			</ul>
		</div>
	</div>
);

export default EtdDetails;
